module.exports = __webpack_public_path__ + "assets/img/af671723879b0b8c98872f428d176932.svg";